import { FILE_URI_SCHEME, toFileUri } from '@unifyapps/network/utils/fileUri';

const DOUBLED_FILE_URI_REGEX = /^file:\/\/file:\/\//;

/** URIs that are not bare filesystem paths — do not prepend `file://`; safe to load via `fetch` in RN. */
export const NON_FILE_URI_REGEX = /^(data:|https?:\/\/|content:\/\/)/;

// Interminently file uri is coming as file://file://
// this function normalizes the file uri
export function sanitizeFileUri(sourceFileUri?: string) {
  if (!sourceFileUri) return '';

  // non-file URIs (data:, http(s)://, content://) must not be touched
  if (NON_FILE_URI_REGEX.test(sourceFileUri)) return sourceFileUri;

  const collapsed = sourceFileUri.replace(DOUBLED_FILE_URI_REGEX, FILE_URI_SCHEME);
  return collapsed ? toFileUri(collapsed) : collapsed;
}
